import { connect } from 'react-redux'
import { compose, lifecycle, withStateHandlers, withHandlers } from 'recompose'
import { show } from 'redux-modal'
import { isEqual } from 'lodash'
import withType from 'components/common/hoc/withType'
import { getQuoteItemAndServices } from 'selectors/shoppingData'
import { getCurrentStoreNumber } from 'selectors/getCurrentStore'
import { SIX_MONTHS } from './constants'
import { getCitiFinancingPromoExcludedStores } from 'components/ShoppingQuote/actions'
import { injectDynamicVerbiage } from './helpers'
import BOTPaymentOptionsBanner from './BOTPaymentOptionsBanner'

const mapStateToProps = state => ({
  quotedItemAndServices: getQuoteItemAndServices(state),
  storeNumber: getCurrentStoreNumber(state)
})

const withPaymentOptionsBannerState = withStateHandlers({
  paymentOptionsBannerContent: null,
  citiFinancingPromoExcludedStores: {}
},
{
  setPaymentOptionsBannerContent: () => paymentOptionsBannerContent => ({ paymentOptionsBannerContent }),
  setCitiFinancingPromoExcludedStores: () => citiFinancingPromoExcludedStores => ({ citiFinancingPromoExcludedStores })
})

const withPaymentOptionsBannerHandlers = withHandlers({
  evaluateEstimatedTotal: ({
    storeNumber,
    setPaymentOptionsBannerContent,
    paymentOptionsBannerTemplate = ''
  }) => ({
    estimatedTotal,
    citiFinancingPromoExcludedStores: {
      sixMonths = ''
    } = {}
  }) =>
    setTimeout(() => {
      const paymentOption = estimatedTotal > 249.99 ? SIX_MONTHS : ''
      const threePaymentsValue = (estimatedTotal / 3).toFixed(2)
      const monthlyPaymentAmount = (estimatedTotal / Number(paymentOption)).toFixed(2)
      const promoIsStoreEnabled = paymentOption === SIX_MONTHS
        ? !sixMonths.includes(storeNumber)
        : true

      paymentOption && promoIsStoreEnabled ? setPaymentOptionsBannerContent(injectDynamicVerbiage({
        paymentOptionsBannerTemplate,
        estimatedTotal,
        monthlyPaymentAmount,
        paymentOption,
        threePaymentsValue
      })) : setPaymentOptionsBannerContent('')
    })
})

const withInit = lifecycle({
  componentDidMount() {
    const {
      getCitiFinancingPromoExcludedStores,
      setCitiFinancingPromoExcludedStores
    } = this.props
    getCitiFinancingPromoExcludedStores()
      .then(({ contentDetails = {}} = {}) => {
        const citiFinancingPromoExcludedStores = {
          sixMonths: contentDetails.six_months_financing_promo_excluded_stores
        }
        setCitiFinancingPromoExcludedStores(citiFinancingPromoExcludedStores)
      })
  },
  componentDidUpdate({
    storeNumber: prevStoreNumber,
    quotedItemAndServices: { quoteSummary: { estimatedTotal: prevEstimatedTotal } = {}} = {},
    citiFinancingPromoExcludedStores: prevCitiFinancingPromoExcludedStores
  }) {
    const {
      storeNumber,
      citiFinancingPromoExcludedStores,
      evaluateEstimatedTotal,
      quotedItemAndServices: {
        quoteSummary: { estimatedTotal } = {}
      } = {}
    } = this.props

    if (prevStoreNumber !== storeNumber || prevEstimatedTotal !== estimatedTotal ||
      !isEqual(prevCitiFinancingPromoExcludedStores, citiFinancingPromoExcludedStores)) {
      evaluateEstimatedTotal({ estimatedTotal, citiFinancingPromoExcludedStores })
    }
  }
})

export default compose(
  withType({ type: 'BOTPaymentOptionsBanner' }),
  connect(mapStateToProps, { show, getCitiFinancingPromoExcludedStores }),
  withPaymentOptionsBannerState,
  withPaymentOptionsBannerHandlers,
  withInit
)(BOTPaymentOptionsBanner)
